import type {
  OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum,
  OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {SupportedCurrency} from 'src/v2/state/types';

export const REFUNDABLE_REASONS = new Set([
  'DEPOSITED_AMOUNT_TOO_LOW_TO_FILL',
  'ORIGIN_CURRENCY_MISMATCH',
  'DEPOSIT_CHAIN_MISMATCH',
]);

const RELAY_INPUT_CURRENCIES: Record<
  OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum,
  true
> = {
  btc: true,
  eth: true,
  sol: true,
  usdc: true,
  usdt: true,
};

const RELAY_INPUT_CHAINS: Record<
  OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum,
  true
> = {
  base: true,
  bitcoin: true,
  ethereum: true,
  polygon: true,
  solana: true,
};

export type RelaySupportedCurrency = Omit<
  SupportedCurrency,
  'assetCode' | 'currencyNetwork'
> & {
  assetCode: OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum;
  currencyNetwork: OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum;
};

const isRelayInputCurrency = (
  assetCode: SupportedCurrency['assetCode'],
): assetCode is OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum =>
  assetCode in RELAY_INPUT_CURRENCIES;

const isRelayInputChain = (
  currencyNetwork: SupportedCurrency['currencyNetwork'],
): currencyNetwork is OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum =>
  currencyNetwork in RELAY_INPUT_CHAINS;

export const isRelaySupportedCurrency = (
  currency: SupportedCurrency,
): currency is RelaySupportedCurrency =>
  isRelayInputCurrency(currency.assetCode) &&
  isRelayInputChain(currency.currencyNetwork);
